import React, { useState, useEffect } from 'react'; 
import "./App.css";

// Router
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";

// Components
import Footer from "./components/footer";
import ScrollBar from "./components/scrollbar";
import Navbar from "./components/navbar";
import Loading from './components/loading';

// Pages
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Datasets from "./pages/Datasets";
import Publications from "./pages/Publications";
import About from "./pages/About";
import Team from "./pages/Team";

// Defining routes for different pages
const routes = [
    { key: 0, path: "*", element: <Navigate to="/" /> },  // Redirect to Home page for unknown paths
    { key: 1, path: "/", element: <Home /> },  // Home page
    { key: 2, path: "/dashboard", element: <Dashboard /> },  // Dashboard page
    { key: 3, path: "/datasets", element: <Datasets /> },  // Datasets page
    { key: 4, path: "/publications", element: <Publications /> },  // Publications page
    { key: 5, path: "/about", element: <About /> },  // About page
    { key: 6, path: "/team", element: <Team /> },  // Team page
];

function App() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Simulate a delay for loading
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000); 

        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return <Loading />;
    }

    return (
        <React.StrictMode>
            {/* Router component manages navigation */}
            <Router>
                {/* Navbar component for navigation links */}
                <Navbar />
                
                {/* Routes component defines application routes */}
                <Routes>
                    {/* Map through defined routes and render corresponding components */}
                    {routes.map((route) => (
                        <Route key={route.key} path={route.path} element={route.element} />
                    ))}
                </Routes>
                
                {/* ScrollBar component to go up of a page */}
                <ScrollBar />
                
                {/* Footer component  */}
                <Footer />
            </Router>
        </React.StrictMode>
    );
}

export default App;
